import React, {type PropsWithChildren, createContext, useContext} from 'react'

type StatusContextValue = {
  isFetching: boolean
}

type StatusContextProps = PropsWithChildren<StatusContextValue>

export const StatusContext = createContext<StatusContextValue>({isFetching: false})

export const StatusProvider = ({children, ...contextValue}: StatusContextProps) => (
  <StatusContext.Provider value={contextValue}>{children}</StatusContext.Provider>
)

export function useStatusContext(): StatusContextValue {
  const context = useContext(StatusContext)

  if (!context) {
    throw new Error('useStatusContext has to be used within StatusProvider')
  }

  return context
}
